import { Link, Outlet } from 'react-router';
import { Sidebar } from '@components';
import { useBreadcrumbs } from '@shared/hooks/useBreadcrumbs';
import { useUrlAssetScope, buildScopedSearch } from '@hooks';
import AssetScopeBar from '@/features/asset-scope/AssetScopeBar';
import styles from './DashboardLayout.module.css';

function DashboardLayout({ layoutDirection = 'row' }) {
  const breadcrumbs = useBreadcrumbs();
  const { siteId, assetId } = useUrlAssetScope();
  const scopeQuery = buildScopedSearch('', { siteId, assetId });

  return (
    <div className={styles.dashboardLayout}>
      <Sidebar />
      <div className={styles.mainContent}>
        <nav className={styles.breadcrumbs} aria-label="Breadcrumb">
          {breadcrumbs.map((crumb, index) => (
            <span key={crumb.path}>
              {index > 0 && <span className={styles.separator} aria-hidden="true">/</span>}
              {index === breadcrumbs.length - 1 ? (
                <span aria-current="page">{crumb.label}</span>
              ) : (
                <Link to={{
                  pathname: crumb.path,
                  search: scopeQuery ? '?' + scopeQuery : '',
                }}>{crumb.label}</Link>
              )}
            </span>
          ))}
        </nav>
        <AssetScopeBar />
        <div className={styles.outlet} style={{ flexDirection: layoutDirection }}>
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default DashboardLayout;